import {
  ChamberMemberProPagePermissionsEnum,
  CmpInvoiceKindEnum,
  UserType,
} from "../../../../graphql/types";

export const canManageEventInvoiceFinancialActions = ({
  enabledPagePermissions,
  invoiceKind,
  userType,
}: {
  enabledPagePermissions: readonly ChamberMemberProPagePermissionsEnum[];
  invoiceKind: CmpInvoiceKindEnum;
  userType?: UserType | null;
}) => {
  if (
    invoiceKind !== CmpInvoiceKindEnum.EventRegistration &&
    invoiceKind !== CmpInvoiceKindEnum.EventSponsorship
  ) {
    return true;
  }

  if (userType === UserType.ChamberAdmin) {
    return true;
  }

  if (userType !== UserType.ChamberStaff) {
    return false;
  }

  if (invoiceKind === CmpInvoiceKindEnum.EventRegistration) {
    return enabledPagePermissions.includes(
      ChamberMemberProPagePermissionsEnum.ChamberAdminEventsManageTicketSales
    );
  }

  if (invoiceKind === CmpInvoiceKindEnum.EventSponsorship) {
    return enabledPagePermissions.includes(
      ChamberMemberProPagePermissionsEnum.ChamberAdminEventsManageSponsorshipSales
    );
  }

  return false;
};

/**
 * Text for a staff user who cannot change an event invoice. The page
 * permission names the sidebar page (Events & Sponsorships > Manage Tickets
 * or Manage Sponsorship) that the chamber administrator can give access to.
 */
export const getEventInvoiceAccessText = (invoiceKind: CmpInvoiceKindEnum) =>
  invoiceKind === CmpInvoiceKindEnum.EventSponsorship
    ? "You do not have access to Manage Sponsorship, so you cannot change sponsorship invoices. Ask your chamber administrator for access."
    : "You do not have access to Manage Tickets, so you cannot change ticket invoices. Ask your chamber administrator for access.";
